import type { ApiResponse, ListResult } from '~/types';
import type { MemberProductCollection } from '~/types/MemberProductCollection';
import type { NitroFetchRequest, $Fetch } from 'nitropack'
export const productCollectionRepository = () => ({
    async createProductCollection(productCollection: MemberProductCollection) {
        return await useAPIFetch<ApiResponse<number>>('/member/productCollection/add', {
            method: 'POST',
            body: productCollection,
        });
    },

    async deleteProductCollection(id: number) {
        return await useAPIFetch<ApiResponse<number>>('/member/productCollection/delete', {
            method: 'POST',
            params: { productId: id },
        });
    },

    async fetchProductCollectionList(pageNum: number, pageSize: number) {
        return await useAPIFetch<ApiResponse<ListResult<MemberProductCollection>>>(
            '/member/productCollection/list',
            {
                params: { pageNum, pageSize },
            },

        );
    },

    async productCollectionDetail(productId: number) {
        return await useAPI<ApiResponse<MemberProductCollection>>(
            '/member/productCollection/detail',
            {
                params: { productId },
            }
        );
    },

    async clearProductCollection() {
        return await useAPIFetch<ApiResponse<number>>('/member/productCollection/clear', {
            method: 'POST',
        });
    },
});
